import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "../scss/components/_rentreceiptmodal.scss";

/* ---------- Inline icons ---------- */

const HouseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 11.5L12 4l8 7.5"
      stroke="#fff"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 10.5V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8.5"
      stroke="#fff"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 20v-5h4v5" stroke="#fff" strokeWidth="2.2" strokeLinejoin="round" />
  </svg>
);

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.5" y="5" width="17" height="16" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3.5 9.5h17" stroke="currentColor" strokeWidth="1.8" />
    <path d="M8 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const CardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="6" width="18" height="13" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M3 10.5h18" stroke="currentColor" strokeWidth="1.8" />
    <path d="M6.5 15h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const HashIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 3.5l-3 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M17.5 3.5l-3 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M4 9h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M3 15h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const DocumentIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.5 3.5h8l4 4v13a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path d="M14.5 3.5v4h4" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    <path d="M8 12.5h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M8 16h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const DownloadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11l5 5 5-5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const LoadingSpinner = () => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className="rent-receipt-modal__spinner"
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" opacity="0.3"/>
    <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

/* ---------- RentReceipt Component (Modal) ---------- */

const RentReceipt = ({
  pgName = "Alka PG Paying Guest",
  paidBy = "Vivek",
  amount = "7,500",
  paidOn = "24 Jul 2026",
  period = "1 Jul – 31 Jul 2026",
  periodLabel = "Rent Period",
  paymentMethod = "UPI",
  receiptNo = "UPI123456",
  receiptNumber = "RCPT-2026-000001",
  receiptType = "PAYMENT",
  onClose,
  roomNumber = "G101",
  bedNumber = "B1",
  paymentSummary = [
    { ReferenceType: "RENT", Amount: 5000 },
    { ReferenceType: "ELECTRICITY", Amount: 1200 },
    { ReferenceType: "EXPENSE", Amount: 300 },
    { ReferenceType: "ADVANCE", Amount: 1000 }
  ],
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [visible, setVisible] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const receiptRef = useRef(null);

  if (!visible) return null;

  const getReceiptLabel = () => {
    if (receiptType === 'PAYMENT') {
      return 'PAYMENT RECEIPT';
    }
    return `${receiptType} RECEIPT`;
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setVisible(false);
      if (onClose) {
        onClose();
      }
    }, 300);
  };


  const truncatedPgName = pgName.length > 15 ? pgName.slice(0, 15) + '...' : pgName;
  
  const fullPgName = pgName;

  // const handleDownloadPDF = async () => {
  //   setIsDownloading(true);
    
  //   try {
  //     const receiptElement = receiptRef.current?.querySelector('.rent-receipt__card');
      
  //     if (!receiptElement) {
  //       console.error("Receipt element not found");
  //       setIsDownloading(false);
  //       return;
  //     }

  //     // Clone the element to render at full size without modal constraints
  //     const clone = receiptElement.cloneNode(true);
      
  //     // --- FIX: Ensure full text visibility in PDF ---
  //     // Fix PG Name - remove any text truncation/overflow
  //     const pgNameElement = clone.querySelector('.rent-receipt__pg-name');
  //     if (pgNameElement) {
  //       pgNameElement.style.whiteSpace = 'normal';
  //       pgNameElement.style.overflow = 'visible';
  //       pgNameElement.style.textOverflow = 'clip';
  //       pgNameElement.style.wordBreak = 'break-word';
  //       pgNameElement.style.maxWidth = '100%';
  //       pgNameElement.style.display = 'flex';
  //       pgNameElement.style.flexWrap = 'wrap';
  //       pgNameElement.style.alignItems = 'center';
  //       pgNameElement.style.gap = '4px';
  //     }
      
  //     // Fix room/bed display
  //     const roomBedElement = clone.querySelector('.rent-receipt__room-bed');
  //     if (roomBedElement) {
  //       roomBedElement.style.whiteSpace = 'nowrap';
  //       roomBedElement.style.flexShrink = '0';
  //     }
      
  //     // Fix brand info container
  //     const brandInfoElement = clone.querySelector('.rent-receipt__brand-info');
  //     if (brandInfoElement) {
  //       brandInfoElement.style.minWidth = '0';
  //       brandInfoElement.style.maxWidth = '100%';
  //     }
      
  //     // Fix brand container
  //     const brandElement = clone.querySelector('.rent-receipt__brand');
  //     if (brandElement) {
  //       brandElement.style.minWidth = '0';
  //       brandElement.style.maxWidth = '100%';
  //       brandElement.style.flexWrap = 'wrap';
  //     }
  //     // --- END FIX ---

  //     clone.style.position = 'fixed';
  //     clone.style.left = '-9999px';
  //     clone.style.top = '0';
  //     clone.style.maxWidth = '600px';
  //     clone.style.width = '600px';
  //     clone.style.transform = 'scale(1)';
  //     clone.style.borderRadius = '16px';
  //     clone.style.boxShadow = '0 20px 60px rgba(0,0,0,0.1)';
  //     clone.style.padding = '20px'; // Add some padding
  //     document.body.appendChild(clone);

  //     // Wait for DOM to update
  //     await new Promise(resolve => setTimeout(resolve, 100));

  //     const canvas = await html2canvas(clone, {
  //       scale: 2,
  //       useCORS: true,
  //       backgroundColor: '#ffffff',
  //       logging: false,
  //       width: 600,
  //       height: clone.scrollHeight,
  //       windowWidth: 600,
  //       windowHeight: clone.scrollHeight,
  //       onclone: (clonedDoc) => {
  //         // Additional fixes if needed
  //         const clonedPgName = clonedDoc.querySelector('.rent-receipt__pg-name');
  //         if (clonedPgName) {
  //           clonedPgName.style.whiteSpace = 'normal';
  //           clonedPgName.style.overflow = 'visible';
  //           clonedPgName.style.textOverflow = 'clip';
  //         }
  //       }
  //     });

  //     document.body.removeChild(clone);

  //     const imgData = canvas.toDataURL('image/png');
      
  //     const pdf = new jsPDF({
  //       orientation: 'portrait',
  //       unit: 'px',
  //       format: [canvas.width + 40, canvas.height + 40],
  //     });

  //     pdf.setFillColor(255, 255, 255);
  //     pdf.rect(0, 0, canvas.width + 40, canvas.height + 40, 'F');
  //     pdf.addImage(imgData, 'PNG', 20, 20, canvas.width, canvas.height);
  //     pdf.save(`Receipt-${receiptNumber || 'download'}.pdf`);

  //   } catch (error) {
  //     console.error("Error downloading PDF:", error);
  //   } finally {
  //     setIsDownloading(false);
  //   }
  // };

  
  const handleDownloadPDF = async () => {
    setIsDownloading(true);
    
    try {
      const receiptElement = receiptRef.current?.querySelector('.rent-receipt__card');
      
      if (!receiptElement) {
        console.error("Receipt element not found");
        setIsDownloading(false);
        return;
      }

      const clone = receiptElement.cloneNode(true);
      
      // --- FIX: Replace truncated name with full name in PDF clone ---
      const pgNameElement = clone.querySelector('.rent-receipt__pg-name');
      if (pgNameElement) {
        // Get the text node that contains the pg name (excluding room/bed)
        const textNodes = [];
        const walker = document.createTreeWalker(
          pgNameElement,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        
        let node;
        while (node = walker.nextNode()) {
          // Skip the room/bed text node if it's in a span
          if (node.parentElement?.classList?.contains('rent-receipt__room-bed')) {
            continue;
          }
          textNodes.push(node);
        }
        
        // Replace the first text node with full pg name
        if (textNodes.length > 0) {
          textNodes[0].textContent = fullPgName;
        } else {
          // If no text node found, set the whole innerHTML
          const roomBedElement = pgNameElement.querySelector('.rent-receipt__room-bed');
          const roomBedHtml = roomBedElement ? roomBedElement.outerHTML : '';
          pgNameElement.innerHTML = `${fullPgName} ${roomBedHtml}`;
        }
      }
      
      // Fix PG Name - remove any text truncation/overflow
      if (pgNameElement) {
        pgNameElement.style.whiteSpace = 'normal';
        pgNameElement.style.overflow = 'visible';
        pgNameElement.style.textOverflow = 'clip';
        pgNameElement.style.wordBreak = 'break-word';
        pgNameElement.style.maxWidth = '100%';
        pgNameElement.style.display = 'flex';
        pgNameElement.style.flexWrap = 'wrap';
        pgNameElement.style.alignItems = 'center';
        pgNameElement.style.gap = '4px';
      }
      
      // Fix room/bed display
      const roomBedElement = clone.querySelector('.rent-receipt__room-bed');
      if (roomBedElement) {
        roomBedElement.style.whiteSpace = 'nowrap';
        roomBedElement.style.flexShrink = '0';
      }
      
      // Fix brand info container
      const brandInfoElement = clone.querySelector('.rent-receipt__brand-info');
      if (brandInfoElement) {
        brandInfoElement.style.minWidth = '0';
        brandInfoElement.style.maxWidth = '100%';
      }
      
      // Fix brand container
      const brandElement = clone.querySelector('.rent-receipt__brand');
      if (brandElement) {
        brandElement.style.minWidth = '0';
        brandElement.style.maxWidth = '100%';
        brandElement.style.flexWrap = 'wrap';
      }
      // --- END FIX ---

      clone.style.position = 'fixed';
      clone.style.left = '-9999px';
      clone.style.top = '0';
      clone.style.maxWidth = '600px';
      clone.style.width = '600px';
      clone.style.transform = 'scale(1)';
      clone.style.borderRadius = '16px';
      clone.style.boxShadow = '0 20px 60px rgba(0,0,0,0.1)';
      clone.style.padding = '20px';
      document.body.appendChild(clone);

      await new Promise(resolve => setTimeout(resolve, 100));

      const canvas = await html2canvas(clone, {
        scale: 1.5,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: 600,
        height: clone.scrollHeight,
        windowWidth: 600,
        windowHeight: clone.scrollHeight,
      });

      document.body.removeChild(clone);

      const imgData = canvas.toDataURL('image/jpeg', 0.8);
      
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: [canvas.width + 40, canvas.height + 40],
         compress: true,
      });

      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, canvas.width + 40, canvas.height + 40, 'F');
      pdf.addImage(imgData, 'PNG', 20, 20, canvas.width, canvas.height);
      pdf.save(`Receipt-${receiptNumber || 'download'}.pdf`);

    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const isMixedPayment = receiptType === 'PAYMENT';
  const displaySummary = paymentSummary;

  const roomBedDisplay = roomNumber && bedNumber ? `(${roomNumber}, ${bedNumber})` : 
                         roomNumber ? `(${roomNumber})` : 
                         bedNumber ? `(Bed ${bedNumber})` : '';

  const formatLabel = (type) => {
    return type.charAt(0) + type.slice(1).toLowerCase();
  };

  return (
    <div 
      className={`rent-receipt-modal ${isClosing ? 'rent-receipt-modal--closing' : ''}`}
      onClick={handleBackdropClick}
    >
      <div className="rent-receipt-modal__container" ref={receiptRef}>
        {/* Modal Header */}
        <div className="rent-receipt-modal__header">
          <button
            type="button"
            className="rent-receipt-modal__download-btn"
            onClick={handleDownloadPDF}
            disabled={isDownloading}
            aria-label="Download receipt as PDF"
          >
            {isDownloading ? (
              <>
                <LoadingSpinner />
                <span>Generating PDF...</span>
              </>
            ) : (
              <>
                <DownloadIcon />
                <span>Download PDF</span>
              </>
            )}
          </button>
          <button
            type="button"
            className="rent-receipt-modal__close-btn"
            onClick={handleClose}
            aria-label="Close receipt"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Receipt Content */}
        <div className="rent-receipt-modal__content">
          <div className="rent-receipt">
            <div className="rent-receipt__card">
              {/* ─── Header ────────────────────────────────────────── */}
              <div className="rent-receipt__header">
                <div className="rent-receipt__brand">
                  <div className="rent-receipt__logo">
                    <HouseIcon />
                  </div>
                  <div className="rent-receipt__brand-info">
                    <span className="rent-receipt__pg-name">
                      {truncatedPgName} 
                      {roomBedDisplay && (
                        <span className="rent-receipt__room-bed"> {roomBedDisplay}</span>
                      )}
                    </span>
                    <span className="rent-receipt__receipt-type">{getReceiptLabel()}</span>
                  </div>
                </div>
              </div>

              {/* ─── Hero ──────────────────────────────────────────── */}
              <div className="rent-receipt__hero">
                <div className="rent-receipt__paid-by">
                  <span className="rent-receipt__label">Paid By</span>
                  <span className="rent-receipt__paid-by-name">{paidBy}</span>
                </div>
                <img className="rent-receipt__illustration" src="/assets/rent-receipt-building-illustration.png" alt="" />
              </div>

              <div className="rent-receipt__divider" />

              {/* ─── Amount Section with Payment Summary ──────────── */}
              <div className="rent-receipt__amount-section">
                <div className="rent-receipt__amount-left">
                  <span className="rent-receipt__label">AMOUNT PAID</span>
                  <div className="rent-receipt__amount-wrapper">
                    <div className="rent-receipt__amount">
                      <span className="rent-receipt__currency">₹</span>
                      {amount}
                    </div>
                    <span className="rent-receipt__paid-on">Paid on {paidOn}</span>
                  </div>
                </div>
                
                {isMixedPayment && displaySummary.length > 0 && (
                  <div className="rent-receipt__payment-summary">
                    <span className="rent-receipt__label">PAYMENT SUMMARY</span>
                    <div className="rent-receipt__summary-grid">
                      {displaySummary.map((item, index) => (
                        <div key={index} className="rent-receipt__summary-row">
                          <span className="rent-receipt__summary-label">
                            {formatLabel(item.ReferenceType)}
                          </span>
                          <span className="rent-receipt__summary-value">
                            ₹{Number(item.Amount).toLocaleString('en-IN')}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="rent-receipt__divider" />

              {/* ─── Payment Details ──────────────────────────────── */}
              <div className="rent-receipt__details-section">
                <span className="rent-receipt__label rent-receipt__details-title">
                  PAYMENT DETAILS
                </span>

                <div className="rent-receipt__detail-row">
                  <span className="rent-receipt__detail-icon">
                    <CalendarIcon />
                  </span>
                  <span className="rent-receipt__detail-label">{periodLabel}</span>
                  <span className="rent-receipt__detail-value">{period}</span>
                </div>

                <div className="rent-receipt__detail-row">
                  <span className="rent-receipt__detail-icon">
                    <CardIcon />
                  </span>
                  <span className="rent-receipt__detail-label">Payment Method</span>
                  <span className="rent-receipt__detail-value">{paymentMethod}</span>
                </div>

                <div className="rent-receipt__detail-row">
                  <span className="rent-receipt__detail-icon">
                    <HashIcon />
                  </span>
                  <span className="rent-receipt__detail-label">Reference No.</span>
                  <span className="rent-receipt__detail-value">{receiptNo}</span>
                </div>

                <div className="rent-receipt__detail-row rent-receipt__detail-row--last">
                  <span className="rent-receipt__detail-icon">
                    <DocumentIcon />
                  </span>
                  <span className="rent-receipt__detail-label">Receipt No.</span>
                  <span className="rent-receipt__detail-value">{receiptNumber}</span>
                </div>
              </div>

              {/* ─── Footer ────────────────────────────────────────── */}
              <div className="rent-receipt__footer">
                <span>Managed and powered by</span>
                <span className="rent-receipt__footer-brand">
                  <img src="/assets/AapkaPG-logo.svg" alt="AapkaPG" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RentReceipt;

// import React, { useState, useRef } from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import "../scss/components/_rentreceiptmodal.scss";

// /* ---------- Inline icons ---------- */

// const HouseIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path
//       d="M4 11.5L12 4l8 7.5"
//       stroke="#fff"
//       strokeWidth="2.2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M6 10.5V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-8.5"
//       stroke="#fff"
//       strokeWidth="2.2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path d="M10 20v-5h4v5" stroke="#fff" strokeWidth="2.2" strokeLinejoin="round" />
//   </svg>
// );

// const CalendarIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <rect x="3.5" y="5" width="17" height="16" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
//     <path d="M3.5 9.5h17" stroke="currentColor" strokeWidth="1.8" />
//     <path d="M8 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//     <path d="M16 3v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//   </svg>
// );

// const CardIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <rect x="3" y="6" width="18" height="13" rx="2.2" stroke="currentColor" strokeWidth="1.8" />
//     <path d="M3 10.5h18" stroke="currentColor" strokeWidth="1.8" />
//     <path d="M6.5 15h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//   </svg>
// );

// const HashIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path d="M9.5 3.5l-3 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//     <path d="M17.5 3.5l-3 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//     <path d="M4 9h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//     <path d="M3 15h16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//   </svg>
// );

// const DocumentIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path
//       d="M6.5 3.5h8l4 4v13a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-16a1 1 0 0 1 1-1z"
//       stroke="currentColor"
//       strokeWidth="1.8"
//       strokeLinejoin="round"
//     />
//     <path d="M14.5 3.5v4h4" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
//     <path d="M8 12.5h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//     <path d="M8 16h8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
//   </svg>
// );

// const CloseIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path
//       d="M6 6l12 12M18 6L6 18"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// const DownloadIcon = () => (
//   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//     <path
//       d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M7 11l5 5 5-5"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M12 16V3"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//     />
//   </svg>
// );

// const LoadingSpinner = () => (
//   <svg 
//     viewBox="0 0 24 24" 
//     fill="none" 
//     xmlns="http://www.w3.org/2000/svg"
//     className="rent-receipt-modal__spinner"
//   >
//     <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" opacity="0.3"/>
//     <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
//   </svg>
// );

// /* ---------- RentReceipt Component (Modal) ---------- */

// const RentReceipt = ({
//   pgName = "Alka PG Paying Guest",
//   paidBy = "Vivek",
//   amount = "7,500",
//   paidOn = "24 Jul 2026",
//   period = "1 Jul – 31 Jul 2026",
//   periodLabel = "Rent Period",
//   paymentMethod = "UPI",
//   receiptNo = "UPI123456",
//   receiptNumber = "RCPT-2026-000001",
//   receiptType = "PAYMENT",
//   onClose,
//   roomNumber = "G101",
//   bedNumber = "B1",
//   paymentSummary = [
//     { ReferenceType: "RENT", Amount: 5000 },
//     { ReferenceType: "ELECTRICITY", Amount: 1200 },
//     { ReferenceType: "EXPENSE", Amount: 300 },
//     { ReferenceType: "ADVANCE", Amount: 1000 }
//   ],
// }) => {
//   const [isClosing, setIsClosing] = useState(false);
//   const [visible, setVisible] = useState(true);
//   const [isDownloading, setIsDownloading] = useState(false);
//   const receiptRef = useRef(null);

//   if (!visible) return null;

//   const getReceiptLabel = () => {
//     if (receiptType === 'PAYMENT') {
//       return 'PAYMENT RECEIPT';
//     }
//     return `${receiptType} RECEIPT`;
//   };

//   const handleClose = () => {
//     setIsClosing(true);
//     setTimeout(() => {
//       setVisible(false);
//       if (onClose) {
//         onClose();
//       }
//     }, 300);
//   };

//   const handleDownloadPDF = async () => {
//     setIsDownloading(true);
    
//     try {
//       const receiptElement = receiptRef.current?.querySelector('.rent-receipt__card');
      
//       if (!receiptElement) {
//         console.error("Receipt element not found");
//         setIsDownloading(false);
//         return;
//       }

//       // Clone the element to render at full size without modal constraints
//       const clone = receiptElement.cloneNode(true);
//       clone.style.position = 'fixed';
//       clone.style.left = '-9999px';
//       clone.style.top = '0';
//       clone.style.maxWidth = '600px';
//       clone.style.width = '600px';
//       clone.style.transform = 'scale(1)';
//       clone.style.borderRadius = '16px';
//       clone.style.boxShadow = '0 20px 60px rgba(0,0,0,0.1)';
//       document.body.appendChild(clone);

//       const canvas = await html2canvas(clone, {
//         scale: 2,
//         useCORS: true,
//         backgroundColor: '#ffffff',
//         logging: false,
//         width: 600,
//         height: clone.scrollHeight,
//         windowWidth: 600,
//         windowHeight: clone.scrollHeight,
//       });

//       document.body.removeChild(clone);

//       const imgData = canvas.toDataURL('image/png');
      
//       const pdf = new jsPDF({
//         orientation: 'portrait',
//         unit: 'px',
//         format: [canvas.width + 40, canvas.height + 40],
//       });

//       pdf.setFillColor(255, 255, 255);
//       pdf.rect(0, 0, canvas.width + 40, canvas.height + 40, 'F');
//       pdf.addImage(imgData, 'PNG', 20, 20, canvas.width, canvas.height);
//       pdf.save(`Receipt-${receiptNumber || 'download'}.pdf`);

//     } catch (error) {
//       console.error("Error downloading PDF:", error);
//     } finally {
//       setIsDownloading(false);
//     }
//   };

//   const handleBackdropClick = (e) => {
//     if (e.target === e.currentTarget) {
//       handleClose();
//     }
//   };

//   const isMixedPayment = receiptType === 'PAYMENT';
//   const displaySummary = paymentSummary;

//   const roomBedDisplay = roomNumber && bedNumber ? `(${roomNumber}, ${bedNumber})` : 
//                          roomNumber ? `(${roomNumber})` : 
//                          bedNumber ? `(Bed ${bedNumber})` : '';

//   const formatLabel = (type) => {
//     return type.charAt(0) + type.slice(1).toLowerCase();
//   };

//   return (
//     <div 
//       className={`rent-receipt-modal ${isClosing ? 'rent-receipt-modal--closing' : ''}`}
//       onClick={handleBackdropClick}
//     >
//       <div className="rent-receipt-modal__container" ref={receiptRef}>
//         {/* Modal Header */}
//         <div className="rent-receipt-modal__header">
//           <button
//             type="button"
//             className="rent-receipt-modal__download-btn"
//             onClick={handleDownloadPDF}
//             disabled={isDownloading}
//             aria-label="Download receipt as PDF"
//           >
//             {isDownloading ? (
//               <>
//                 <LoadingSpinner />
//                 <span>Generating PDF...</span>
//               </>
//             ) : (
//               <>
//                 <DownloadIcon />
//                 <span>Download PDF</span>
//               </>
//             )}
//           </button>
//           <button
//             type="button"
//             className="rent-receipt-modal__close-btn"
//             onClick={handleClose}
//             aria-label="Close receipt"
//           >
//             <CloseIcon />
//           </button>
//         </div>

//         {/* Receipt Content */}
//         <div className="rent-receipt-modal__content">
//           <div className="rent-receipt">
//             <div className="rent-receipt__card">
//               {/* ─── Header ────────────────────────────────────────── */}
//               <div className="rent-receipt__header">
//                 <div className="rent-receipt__brand">
//                   <div className="rent-receipt__logo">
//                     <HouseIcon />
//                   </div>
//                   <div className="rent-receipt__brand-info">
//                     <span className="rent-receipt__pg-name">
//                       {pgName}
//                       {roomBedDisplay && (
//                         <span className="rent-receipt__room-bed"> {roomBedDisplay}</span>
//                       )}
//                     </span>
//                     <span className="rent-receipt__receipt-type">{getReceiptLabel()}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* ─── Hero ──────────────────────────────────────────── */}
//               <div className="rent-receipt__hero">
//                 <div className="rent-receipt__paid-by">
//                   <span className="rent-receipt__label">Paid By</span>
//                   <span className="rent-receipt__paid-by-name">{paidBy}</span>
//                 </div>
//                 <img className="rent-receipt__illustration" src="/assets/rent-receipt-building-illustration.png" alt="" />
//               </div>

//               <div className="rent-receipt__divider" />

//               {/* ─── Amount Section with Payment Summary ──────────── */}
//               <div className="rent-receipt__amount-section">
//                 <div className="rent-receipt__amount-left">
//                   <span className="rent-receipt__label">AMOUNT PAID</span>
//                   <div className="rent-receipt__amount-wrapper">
//                     <div className="rent-receipt__amount">
//                       <span className="rent-receipt__currency">₹</span>
//                       {amount}
//                     </div>
//                     <span className="rent-receipt__paid-on">Paid on {paidOn}</span>
//                   </div>
//                 </div>
                
//                 {isMixedPayment && displaySummary.length > 0 && (
//                   <div className="rent-receipt__payment-summary">
//                     <span className="rent-receipt__label">PAYMENT SUMMARY</span>
//                     <div className="rent-receipt__summary-grid">
//                       {displaySummary.map((item, index) => (
//                         <div key={index} className="rent-receipt__summary-row">
//                           <span className="rent-receipt__summary-label">
//                             {formatLabel(item.ReferenceType)}
//                           </span>
//                           <span className="rent-receipt__summary-value">
//                             ₹{Number(item.Amount).toLocaleString('en-IN')}
//                           </span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>

//               <div className="rent-receipt__divider" />

//               {/* ─── Payment Details ──────────────────────────────── */}
//               <div className="rent-receipt__details-section">
//                 <span className="rent-receipt__label rent-receipt__details-title">
//                   PAYMENT DETAILS
//                 </span>

//                 <div className="rent-receipt__detail-row">
//                   <span className="rent-receipt__detail-icon">
//                     <CalendarIcon />
//                   </span>
//                   <span className="rent-receipt__detail-label">{periodLabel}</span>
//                   <span className="rent-receipt__detail-value">{period}</span>
//                 </div>

//                 <div className="rent-receipt__detail-row">
//                   <span className="rent-receipt__detail-icon">
//                     <CardIcon />
//                   </span>
//                   <span className="rent-receipt__detail-label">Payment Method</span>
//                   <span className="rent-receipt__detail-value">{paymentMethod}</span>
//                 </div>

//                 <div className="rent-receipt__detail-row">
//                   <span className="rent-receipt__detail-icon">
//                     <HashIcon />
//                   </span>
//                   <span className="rent-receipt__detail-label">Reference No.</span>
//                   <span className="rent-receipt__detail-value">{receiptNo}</span>
//                 </div>

//                 <div className="rent-receipt__detail-row rent-receipt__detail-row--last">
//                   <span className="rent-receipt__detail-icon">
//                     <DocumentIcon />
//                   </span>
//                   <span className="rent-receipt__detail-label">Receipt No.</span>
//                   <span className="rent-receipt__detail-value">{receiptNumber}</span>
//                 </div>
//               </div>

//               {/* ─── Footer ────────────────────────────────────────── */}
//               <div className="rent-receipt__footer">
//                 <span>Managed and powered by</span>
//                 <span className="rent-receipt__footer-brand">
//                   <img src="/assets/AapkaPG-logo.svg" alt="AapkaPG" />
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RentReceipt;